import {Get, Post} from "@kkmh/utils";

/**
 * getSummary 获取抽奖奖品列表    Get: /v1/payactivity/lottery/summary
 * @author: gqy
 * 接口文档: https://yapi.quickcan.com/project/347/interface/api/4042
 * 对接后端: 汤冬冬
 * @param activity_name   抽奖活动名称   必填参数
 * 
 * return Promise
 * **/
function getSummary( data={} ){
    return Get({
        url: "/v1/payactivity/lottery/summary",
        data,
    });
}

/**
 * getMyRecordList 获取我的奖励    Get: /v1/payactivity/lottery/award_list
 * @author: gqy
 * 接口文档: https://yapi.quickcan.com/project/347/interface/api/4044
 * 对接后端: 汤冬冬
 * @param activity_name   抽奖活动名称   必填参数
 * 
 * return Promise
 * **/
function getMyRecordList( data={} ){
    return Get({
        url: "/v1/payactivity/lottery/award_list",
        data,
    });
}

/**
 * luckdraw 抽奖    Post: /v1/payactivity/lottery/start
 * @author: gqy
 * 接口文档: https://yapi.quickcan.com/project/347/interface/api/13716
 * 对接后端: 汤冬冬
 * @param activity_name   抽奖活动名称   必填参数
 * 
 * return Promise
 * **/
function luckdraw( data={} ){
    return Post({
        url: "/v1/payactivity/lottery/start",
        data,
        headers:{
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Device": data.xdevice
        }
    });
}

export {
    getSummary, // 获取抽奖活动 奖品列表
    getMyRecordList, // 获取我的奖励
    luckdraw, // 抽奖
};


// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/api/lottery.api.js